export enum PageWidths {
	THIN = 520,
	STANDARD = 720,
	WIDE = 1024,
	EXTRA_WIDE = 1280,
	ULTRA_WIDE = 2560,
}

export enum ActionBarHeight {
	STANDARD = 68,
	MEDIUM = 72,
}

export enum SubNavHeight {
	STANDARD = 49,
}
